import { render, staticRenderFns } from "./Internal-Property.vue?vue&type=template&id=3d4c4fec"
import script from "./Internal-Property.vue?vue&type=script&lang=js"
export * from "./Internal-Property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports